// Change this single value to switch environments.

//export const BASE_API_URL = 'https://api-qe2p.knackgalaxy.com/api/';

export const BASE_API_URL = 'https://api-qe2p.knackgalaxy.com/api/';

// export const BASE_API_URL = 'http://localhost:5122/api/';

// ----------------------------------------------------------------------------------------------------

// Change this single value to switch app/home URL across pages.

export const BASE_APP_URL = 'https://knack-dev.brainvire.net/';

//export const BASE_APP_URL = 'https://www.knackgalaxy.com/';

// ----------------------------------------------------------------------------------------------------

// The O2W module lives in the Knack app (BASE_APP_URL) and is served by its own
// API host — NOT the E2P API above. Keep it in step with BASE_APP_URL when
// switching environments.

export const BASE_O2W_API_URL = 'https://knack-dev-api.brainvire.net/api/';

//export const BASE_O2W_API_URL = 'https://api.knackgalaxy.com/api/';

// ----------------------------------------------------------------------------------------------------

// Host of the O2W screens the E2P grid links to (the "O2W" button on an order row).
// Kept separate from BASE_APP_URL so E2P can run against the dev app while O2W opens production.

export const BASE_O2W_APP_URL = 'https://knack-dev.brainvire.net/';

//export const BASE_O2W_APP_URL = 'https://knackgalaxy.com/';

// ----------------------------------------------------------------------------------------------------

export const appUrl = (path: string) => `${BASE_APP_URL}${path.replace(/^\//, '')}`;
export const o2wAppUrl = (path: string) => `${BASE_O2W_APP_URL}${path.replace(/^\//, '')}`;
export const HOME_URL = appUrl('galaxyHome');
export const LOGIN_URL = BASE_APP_URL;
//export const BASE_API_URL = "http://10.0.0.4:2255/api/";

export const apiUrl = (path: string) =>
  `${BASE_API_URL}${path.replace(/^\//, '')}`;

export const o2wApiUrl = (path: string) =>
  `${BASE_O2W_API_URL}${path.replace(/^\//, '')}`;

export default {
  BASE_API_URL,
  BASE_APP_URL,
  BASE_O2W_API_URL,
  BASE_O2W_APP_URL,
  appUrl,
  o2wAppUrl,
  HOME_URL,
  apiUrl,
  o2wApiUrl,
};

